import { BarChart3, TrendingUp, Scale, Target } from 'lucide-react';
import { fmtUSD } from '../../utils/formatters';
import { calcTradeStats, calcRStats } from '../../services/statsCalculator';

const StatsCards = ({ trades, darkMode }) => {
  const { totalTrades, wins, winRate, totalPnL, profitFactor } = calcTradeStats(trades);
  const { avgR, tradesWithR } = calcRStats(trades);

  const winRateDisplay = winRate.toFixed(1);
  const pfDisplay = profitFactor === Infinity ? '∞' : profitFactor.toFixed(2);
  const avgRDisplay = tradesWithR > 0 && isFinite(avgR)
    ? `${avgR >= 0 ? '+' : ''}${avgR.toFixed(2)}R`
    : '-';

  const cards = [
    {
      title: 'Total Trades',
      value: totalTrades,
      icon: <BarChart3 className="text-blue-500" size={20} />,
      bgColor: darkMode ? 'bg-blue-900/30' : 'bg-blue-50',
      textColor: 'text-blue-600'
    },
    {
      title: 'Total P&L',
      value: `${totalPnL >= 0 ? '' : '-'}$${fmtUSD(totalPnL)}`,
      icon: <TrendingUp className={totalPnL >= 0 ? 'text-green-500' : 'text-red-500'} size={20} />,
      bgColor: totalPnL >= 0 ? (darkMode ? 'bg-green-900/30' : 'bg-green-50') : (darkMode ? 'bg-red-900/30' : 'bg-red-50'),
      textColor: totalPnL >= 0 ? 'text-green-600' : 'text-red-600'
    },
    {
      title: 'Win Rate',
      value: `${winRateDisplay}%`,
      icon: <TrendingUp className="text-purple-500" size={20} />,
      bgColor: darkMode ? 'bg-purple-900/30' : 'bg-purple-50',
      textColor: 'text-purple-600'
    },
    {
      title: 'Winning Trades',
      value: wins,
      icon: <BarChart3 className="text-green-500" size={20} />,
      bgColor: darkMode ? 'bg-green-900/30' : 'bg-green-50',
      textColor: 'text-green-600'
    },
    {
      title: 'Profit Factor',
      value: pfDisplay,
      icon: <Scale className={parseFloat(pfDisplay) >= 1 ? 'text-cyan-500' : 'text-orange-500'} size={20} />,
      bgColor: parseFloat(pfDisplay) >= 1 ? (darkMode ? 'bg-cyan-900/30' : 'bg-cyan-50') : (darkMode ? 'bg-orange-900/30' : 'bg-orange-50'),
      textColor: parseFloat(pfDisplay) >= 1 ? 'text-cyan-600' : 'text-orange-600'
    },
    {
      title: 'Avg R-Multiple',
      value: avgRDisplay,
      icon: <Target className={tradesWithR > 0 && avgR >= 0 ? 'text-teal-500' : tradesWithR > 0 ? 'text-red-500' : 'text-gray-500'} size={20} />,
      bgColor: tradesWithR === 0
        ? (darkMode ? 'bg-gray-800/30' : 'bg-gray-100')
        : avgR >= 0
          ? (darkMode ? 'bg-teal-900/30' : 'bg-teal-50')
          : (darkMode ? 'bg-red-900/30' : 'bg-red-50'),
      textColor: tradesWithR === 0 ? (darkMode ? 'text-gray-500' : 'text-gray-400') : avgR >= 0 ? 'text-teal-600' : 'text-red-600'
    }
  ];

  return (
    <div className="grid grid-cols-3 md:grid-cols-6 gap-3 mb-6">
      {cards.map((card, index) => (
        <div
          key={index}
          className={`p-3 rounded-lg transition-colors duration-300 ${card.bgColor}`}
        >
          <div className="flex items-center gap-2 mb-1">
            {card.icon}
            <span className={`text-xs transition-colors duration-300 ${
              darkMode ? 'text-gray-300' : 'text-gray-600'
            }`}>
              {card.title}
            </span>
          </div>
          <div className={`text-2xl font-bold ${card.textColor}`}>
            {card.value}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;
